import { render, staticRenderFns } from "./billboard.vue?vue&type=template&id=0cb7fb96&"
import script from "./billboard.vue?vue&type=script&lang=js&"
export * from "./billboard.vue?vue&type=script&lang=js&"
import style0 from "./billboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports